import Layout from "@/layout/Layout";
import globalStyle from '@/styles/Global.scss'
import React, {useEffect, useState} from "react";
import {getScheduleListOf} from "@/api/schedule";
import {useHistory, useParams} from "react-router";
import MButton from "@/components/atom/MButton";
import MCalendar from "@/components/atom/MCalendar";

const WatashiSchedule = () => {
  const {id} = useParams()
  const history = useHistory()
  const [schedules, setSchedules] = useState([])

  useEffect(() => {
    (async () => {
      await loadSchedules({id})
    })()
  }, [id])

  const toMenu = () => {
    history.push(`/menu`)
  }

  const onScheduleChange = async () => {
    await loadSchedules()
  }

  const loadSchedules = async ({id}) => {
    const schedules = await getScheduleListOf({userId: id})
    setSchedules(schedules)
  }

  return (
    <>
      <Layout category={'UK'} title={'スケジュール'}>
        <div className={globalStyle.container}>
          <h3>スケジュール</h3>
          <MCalendar schedules={schedules} onChange={onScheduleChange} canEdit={false}/>
          <MButton image={'back.png'} value={'戻る'} onClick={toMenu}></MButton>
        </div>
      </Layout>
    </>
  )
}

export default WatashiSchedule
